/*
 * @Author: Teemo Ding
 * @Date: 2022-04-13 09:28:11
 * @LastEditTime: 2022-06-08 11:40:38
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionList/index.tsx
 */
import { Skeleton } from '@/src/components/Antd';
import CommonHeader from '@/src/components/CommonHeader';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import { getPermissionList } from '@/src/request/settings/permission';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useLocalStorageState, useRequest } from 'ahooks';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { ACCOUNT_INFO as _ACCOUNT_INFO } from 'src/tools/constant';
import { generateKey } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import Security from './Security';
import TransferStoreOwnership from './TransferStoreOwnership';
import Users from './Users';
import { breadcrumbData } from './config';
import css from './style.module.less';

const permissions = () => {
  const view_settings = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsUserPermission,
        operation: EnumOperation.view_settings,
      }),
    ],
  });
  const add_edit_user = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsUserPermission,
        operation: EnumOperation.add_edit_user,
      }),
    ],
  });
  return {
    view_settings,
    add_edit_user,
  };
};
const PermissionList = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { view_settings, add_edit_user } = permissions();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const k = generateKey(_ACCOUNT_INFO);

  const [info] = useLocalStorageState<any>(k);
  const {
    data: {
      requireTfa = false,
      storeOwner = false,
      users = [],
      timeZone = '',
    } = {},
    run: _getPermissionList,
  } = useRequest(() => getPermissionList(get(info, 'storeUuid')), {
    ready: !!view_settings,
  });

  const onGoBackClick = () => {
    setLoading(false);
    history.push({
      pathname: '/settings',
    });
  };

  return (
    <Skeleton loading={loading} active>
      <div className={css.commonContainer}>
        <RouteBlock
          onConfirm={(f) => f()}
          okText={getI18n('general.discard')}
          scrollToFirstError
          title={getI18n('general.commonHeader.discard_header')}
          content={getI18n('general.commonHeader.discard_content')}
        />
        <CommonHeader
          breadcrumbData={breadcrumbData({ getI18n })}
          onGoBackClick={onGoBackClick}
        />
        <Security
          requireTfa={requireTfa}
          onUpdate={_getPermissionList}
          disableEdit={!add_edit_user}
        />
        <Users
          users={users}
          timeZone={timeZone}
          disableView={!view_settings}
          disableAdd={!add_edit_user}
        />
        {storeOwner && <TransferStoreOwnership onUpdate={_getPermissionList} />}
      </div>
    </Skeleton>
  );
};

export default PermissionList;
